import styles from './LogoH1.module.scss'

const LogoH1 = () => {
  return <h1 className={styles.text}>BOXO</h1>
}

export default LogoH1
